/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

import { useRef, useEffect } from 'react';

const useMounted = (): { current: boolean } => {
    const componentIsMounted = useRef(true);
    // console.log('mouting');

    useEffect(
        () => {
            return () => {
                // console.log('unmouting');
                componentIsMounted.current = false;
            };
        },
        []
    );

    return componentIsMounted;
};

export default useMounted;
